import { render, staticRenderFns } from "./NavigatorBottomBarLinkMenu.vue?vue&type=template&id=cc3e04c8"
import script from "./NavigatorBottomBarLinkMenu.vue?vue&type=script&lang=js"
export * from "./NavigatorBottomBarLinkMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports